import { combineReducers } from 'redux';
import { ActionType } from 'typesafe-actions';
import { worldCupMatchesActions } from './actions';
import {
  WORLD_CUP_MATCHES_REQUEST,
  WORLD_CUP_MATCHES_FAILURE,
  WORLD_CUP_MATCHES_SUCCESS,
} from '../../constants/worldCupMatches';
import { WorldCupMatch } from '../../types/WorldCupMatches';

export type WorldCupMatchesState = {
  requested: boolean;
  data: { matches: WorldCupMatch[]; already_published_match_ids: string[] };
  isLoading: boolean;
  error: string | null;
};
export type WorldCupMatchesActions = ActionType<typeof worldCupMatchesActions>;

export const worldCupMatchesReducer = combineReducers<
  WorldCupMatchesState,
  WorldCupMatchesActions
>({
  requested: (state = false, action) => {
    switch (action.type) {
      case WORLD_CUP_MATCHES_REQUEST:
        return true;
      default:
        return state;
    }
  },
  data: (state = { matches: [], already_published_match_ids: [] }, action) => {
    switch (action.type) {
      case WORLD_CUP_MATCHES_SUCCESS:
        return action.payload;
      default:
        return state;
    }
  },
  isLoading: (state = false, action) => {
    switch (action.type) {
      case WORLD_CUP_MATCHES_REQUEST:
        return true;
      default:
        return false;
    }
  },
  error: (state = null, action) => {
    switch (action.type) {
      case WORLD_CUP_MATCHES_FAILURE:
        return action.payload.message || action.payload.detail;
      default:
        return null;
    }
  },
});
